module.exports = __webpack_public_path__ + "img/product28801b.96acba5b.png";